export default "__VITE_ASSET__ee6b9c35__"